import './loading.less';
import AgentRunning from '@src/assets/images/agent_running.png';

export const Loading = ({ content }: { content?: string }) => {
  return (
    <div className="md-render-loading-container">
      <img src={AgentRunning} alt="agent-running" />
      <div className="text-shimmer">{content}</div>
    </div>
  );
};
